import { createStore } from 'effector'
import { PreloadingFlow } from '@store/system/types'
import * as events from '@store/system/events'
import EventEmitter from '@services/event-bus'
import { initialConfigCallback } from '@misc/initial-config-callback'

export const $preloadingFlow = createStore<PreloadingFlow>(PreloadingFlow.NONE)
export const $isCornerMode = createStore<boolean>(true)
export const $isOnline = createStore<boolean>(true)

$preloadingFlow.on(events.changePreloadingFlow, (_, next) => next)

$isCornerMode.on(events.toggleCornerMode, (state, next) => (typeof next === 'boolean' ? !next : !state))

$isOnline.on(events.toggleOnline, (state, next) => (next ? next : !state))

$isCornerMode.watch((state) => {
  const value = !state ? 'open' : 'closed'

  initialConfigCallback('onToggle', !state ? 'open' : 'closed')
  EventEmitter.emit('toggle', value)
})
